import { CommandBus } from "./CommandBus";
import { desktopBus, DesktopEvents } from "./EventBus";

interface RegisterCoreCommandsOptions {
  navigate: (path: string) => void;
}

export function registerCoreCommands(
  bus: CommandBus,
  { navigate }: RegisterCoreCommandsOptions,
) {
  const unsubs = [
    bus.register({
      id: "nav.dashboard",
      title: "Open Dashboard",
      category: "Navigation",
      keywords: ["home", "dashboard"],
      run: () => navigate("/dashboard"),
    }),
    bus.register({
      id: "nav.sales",
      title: "Open Sales",
      category: "Navigation",
      keywords: ["invoice", "sales"],
      run: () => navigate("/invoice"),
    }),
    bus.register({
      id: "nav.purchase",
      title: "Open Purchase",
      category: "Navigation",
      keywords: ["purchase"],
      run: () => navigate("/purchasetable"),
    }),
    bus.register({
      id: "nav.products",
      title: "Open Products",
      category: "Navigation",
      keywords: ["stock", "products"],
      run: () => navigate("/stocktable"),
    }),
    bus.register({
      id: "nav.customers",
      title: "Open Customers",
      category: "Navigation",
      keywords: ["customers"],
      run: () => navigate("/customertable"),
    }),
    bus.register({
      id: "nav.reports",
      title: "Open Reports",
      category: "Navigation",
      keywords: ["report", "ledger"],
      run: () => navigate("/overallledger"),
    }),
    bus.register({
      id: "nav.dailyprice",
      title: "Open Daily Price",
      category: "Navigation",
      keywords: ["daily", "price"],
      run: () => navigate("/dailyprice"),
    }),
    bus.register({
      id: "app.commandPalette",
      title: "Open Command Palette",
      category: "Application",
      run: () => desktopBus.emit(DesktopEvents.PALETTE_TOGGLE, { open: true }),
    }),
    bus.register({
      id: "app.universalSearch",
      title: "Open Universal Search",
      category: "Application",
      run: () => desktopBus.emit(DesktopEvents.SEARCH_TOGGLE, { open: true }),
    }),
    bus.register({
      id: "app.sidebarHints",
      title: "Toggle Sidebar Hints",
      category: "Application",
      run: (payload) =>
        desktopBus.emit(DesktopEvents.SIDEBAR_HINTS, {
          visible: Boolean((payload as { visible?: boolean })?.visible),
        }),
    }),
    bus.register({
      id: "ui.closePopup",
      title: "Close Popup",
      category: "Application",
      run: () => {
        document.dispatchEvent(
          new CustomEvent("desktop:close-top-popup", { detail: {} }),
        );
      },
    }),
    bus.register({
      id: "form.save",
      title: "Save Current Form",
      category: "Form",
      run: () => {
        window.dispatchEvent(new CustomEvent("desktop:form-save"));
      },
    }),
    bus.register({
      id: "form.saveAndNew",
      title: "Save And New",
      category: "Form",
      run: () => {
        window.dispatchEvent(new CustomEvent("desktop:form-save-new"));
      },
    }),
    bus.register({
      id: "sales.new",
      title: "Sales New",
      category: "Sales",
      run: () => navigate("/sales"),
    }),
    bus.register({
      id: "invoice.print",
      title: "Print Invoice",
      category: "Sales",
      run: () => {
        window.dispatchEvent(new CustomEvent("desktop:invoice-print"));
      },
    }),
    bus.register({
      id: "cashin.new",
      title: "New Cash In Entry",
      category: "Cashbook",
      run: () => {
        window.dispatchEvent(new CustomEvent("desktop:cash-in-new"));
      },
    }),
    bus.register({
      id: "cashout.new",
      title: "New Cash Out Entry",
      category: "Cashbook",
      run: () => {
        window.dispatchEvent(new CustomEvent("desktop:cash-out-new"));
      },
    }),
    bus.register({
      id: "barcode.scan",
      title: "Process Barcode Scan",
      category: "Inventory",
      run: (payload) => desktopBus.emit(DesktopEvents.BARCODE_SCANNED, payload),
    }),
  ];

  return () => {
    unsubs.forEach((off) => off());
  };
}
